import React from 'react';
import { Typography } from 'antd';
import { WalletIcon } from 'components/Shared/Icons';
import useTranslation from 'utils/hooks/useTranslation';

import styles from './style.module.scss';

const FundingRequestsEmptyState = () => {
  const { translateText } = useTranslation();

  return (
    <div className={styles.emptyState} data-testid="fundingRequestsEmptyState">
      <div className={styles.emptyIconCircle}>
        <WalletIcon />
      </div>
      <Typography.Title className={styles.emptyStateTitle}>
        {translateText('corporateAccounts.fundingRequests.emptyState.title')}
      </Typography.Title>
      <Typography className={styles.emptyStateDescription}>
        {translateText('corporateAccounts.fundingRequests.emptyState.description')}
      </Typography>
    </div>
  );
};

export default FundingRequestsEmptyState;
